var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview-rich"},[(_vm.data.content.value)?_c('div',{staticClass:"rich-wrap",style:(_vm.richStyle),domProps:{"innerHTML":_vm._s(_vm.data.content.value)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }